import { Typography, List, Flex, Card, Space, Row, Col } from 'antd';
import React, { useEffect, useState } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";


const { Title } = Typography;

const KarncyEvaluation = ({ deal }) => {
    const [riskMitigationData, setRiskMitigationData] = useState([])

    useEffect(() => {
        const riskMitigations = Array.isArray(deal?.checkbox) ? [...deal.checkbox] : [];
        if (deal?.isMouSigned !== undefined && deal?.isMouSigned !== null) {
            riskMitigations.push({
                checkboxName: "MOU Signed",
                box: Boolean(deal?.isMouSigned),
            });
        }
        setRiskMitigationData(riskMitigations);
    }, [deal?.checkbox, deal?.isMouSigned]);


    return (
        <div className='karny-evaluation-container'>
            <div className='risk-factors-container'>
                <Typography style={{ fontWeight: 600, color: "#101924", marginBottom: 20 }}>
                    Risk Mitigation Factors
                </Typography>
                <List
                    dataSource={riskMitigationData}
                    size="small"
                    className="custom-list-border"
                    renderItem={(item, index) => (
                        <List.Item key={index}>
                            <Flex align="center" justify="flex-start" gap={10}>
                                {item.box ? (<CheckCircleOutlined style={{ color: "#00874F" }} />) : (
                                    <CloseCircleOutlined style={{ color: "#D92D20" }} />
                                )}
                                <Typography style={{ color: "#101924" }} >{item.checkboxName}</Typography>
                            </Flex>
                        </List.Item>
                    )}
                />
            </div>
            <Title level={5} style={{ marginBottom: 20 }}>
                Repayments History
            </Title>
            <Card>
                {/* Row and Col for responsive layout */}
                <Row gutter={[16, 16]}>
                    <Col xs={12} lg={8}>
                        <Space direction='vertical'>
                            <Typography style={{ fontSize: 12, color: "#40566D" }}>Total Repaid Deals</Typography>
                            <Typography style={{ fontWeight: 600, color: "#101924" }}>{deal?.entRepayHistory?.details?.totalRepaid ?? "Nil"}</Typography>
                        </Space>
                    </Col>
                    <Col xs={12} lg={8}>
                        <Space direction='vertical'>
                            <Typography style={{ fontSize: 12, color: "#40566D" }}>Early Repaid Deals</Typography>
                            <Typography style={{ fontWeight: 600, color: "#101924" }}>{deal?.entRepayHistory?.details?.earlyPayment ?? "Nil"}</Typography>
                        </Space>
                    </Col>
                    <Col xs={12} lg={8}>
                        <Space direction='vertical'>
                            <Typography style={{ fontSize: 12, color: "#40566D" }}>Total Delayed Payments</Typography>
                            <Typography style={{ fontWeight: 600, color: "#101924" }}>{deal?.entRepayHistory?.details?.totalDelayed ?? "Nil"}</Typography>
                        </Space>
                    </Col>
                    <Col xs={12} lg={8}>
                        <Space direction='vertical'>
                            <Typography style={{ fontSize: 12, color: "#40566D" }}>Delayed by 1-5 days</Typography>
                            <Typography style={{ fontWeight: 600, color: "#101924" }}>{deal?.entRepayHistory?.details?.delayed5days ?? "Nil"}</Typography>
                        </Space>
                    </Col>
                    <Col xs={12} lg={8}>
                        <Space direction='vertical'>
                            <Typography style={{ fontSize: 12, color: "#40566D" }}>Delayed by 6-10 days</Typography>
                            <Typography style={{ fontWeight: 600, color: "#101924" }}>{deal?.entRepayHistory?.details?.delayed10days ?? "Nil"}</Typography>
                        </Space>
                    </Col>
                    <Col xs={12} lg={8}>
                        <Space direction='vertical'>
                            <Typography style={{ fontSize: 12, color: "#40566D" }}>{`Delayed by > 10 days`}</Typography>
                            <Typography style={{ fontWeight: 600, color: "#101924" }}>{deal?.entRepayHistory?.details?.morethan10days ?? "Nil"}</Typography>
                        </Space>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default KarncyEvaluation;
